import { useCurrentUserStore } from '@shared/hooks/state/CurrentUserContainer';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../core/button/CoreButton';
import CardCenteredContent from '../core/card/CardCenteredContent';
import ActivateLicenseDialog from './ActivateLicenseDialog';

interface IActivateLicenseCardCenteredContentProps {
    organizationId?: string;
}

export default function ActivateLicenseCardCenteredContent({
    organizationId,
}: IActivateLicenseCardCenteredContentProps) {
    const { t } = useTranslation();
    const [showDialog, setShowDialog] = useState(false);
    const currentUser = useCurrentUserStore((state) => state.currentUser);

    const onDialogCancel = () => {
        setShowDialog(false);
    };

    if (!currentUser?.isEmailVerified) {
        return null;
    }

    const description = organizationId
        ? t('common:license.activate.description')
        : t('common:license.activate.descriptionLong');

    return (
        <>
            <CardCenteredContent
                title={t('common:license.activate.title')}
                description={description}
                name="orgAuthClient">
                <Button $color="secondary" startIcon="plusLight" onClick={() => setShowDialog(true)}>
                    {t('common:license.activate.button')}
                </Button>
            </CardCenteredContent>
            <ActivateLicenseDialog open={showDialog} onCancel={onDialogCancel} organizationId={organizationId} />
        </>
    );
}
